module.exports = __webpack_public_path__ + "static/img/phone.81d75df1.png";